import { Component, Input, OnInit } from '@angular/core';
import { ApplicationInfoModel } from 'app/models/application-info.model';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-form-section-select',
  templateUrl: './form-section-select.component.html',
  styleUrls: ['./form-section-select.component.css']
})
export class FormSectionSelectComponent implements OnInit {
  @Input() formType!: string;
  @Input({required: false}) appInfo!: ApplicationInfoModel;
  
  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.formService.hideErrorSections();
    if(this.appInfo) {
      this.formService.retrieveCaseAndSendFormUpdateMessage(this.appInfo, true);
    }
  }

  get isLoadingForm(): boolean {
    return this.formService.isLoadingForm;
  }
}
